import ConfigEditor from './ConfigEditor'
export default ConfigEditor;